import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { getFromStorage } from '../../utils/storage'
import { DOMAIN } from '../../utils/api'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { Box, Button, Card, FormControlLabel, Switch, TextField } from '@mui/material'
import { currentUserActions } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { mainGreen } from '../../utils/color'

export default function EditStore() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { storeId } = useParams()
	const token = getFromStorage('current-user')?.accessToken
	const [displayTransferInfo, setDisplayTransferInfo] = useState(false)
	const [storeEdit, setStoreEdit] = useState({
		values: {
			name: '',
			bank: '',
			account_name: '',
			account_number: '',
			phone: '',
		},
		errors: { name: '' },
	})

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...storeEdit.values, [name]: value }
		let newError = { ...storeEdit.errors }

		if (name === 'name') {
			if (value.trim() === '') {
				newError[name] = '* Tên cửa hàng không được bỏ trống'
			} else {
				newError[name] = ''
			}
		}

		setStoreEdit({ values: newValue, errors: newError })
	}

	const getStore = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/admin/store/${storeId}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setStoreEdit({
					values: {
						name: response.data.name,
						bank: response.data.bank,
						account_name: response.data.account_name,
						account_number: response.data.account_number,
						phone: response.data.phone,
					},
					errors: { name: '' },
				})
				setDisplayTransferInfo(response.data.display_transfer_info)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, storeId, navigate, dispatch],
	)

	useEffect(() => {
		getStore()
	}, [getStore])

	const editStore = async function () {
		const name = storeEdit.values.name
		const bank = storeEdit.values.bank
		const account_name = storeEdit.values.account_name
		const account_number = storeEdit.values.account_number
		const phone = storeEdit.values.phone

		try {
			const response = await axios({
				url: `${DOMAIN}/admin/edit-store/${storeId}`,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				method: 'PUT',
				data: {
					name,
					bank,
					account_name,
					account_number,
					phone,
					display_transfer_info: displayTransferInfo,
				},
				withCredentials: true,
			})
			if (response.status === 200) {
				alert(response.data.message)
			}
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}
	return (
		<UserLayout>
			<Box sx={{ maxWidth: 992, margin: '0 auto' }}>
				<Card sx={{ margin: '20px 20px 10px 20px', padding: '10px' }}>
					<TextField
						value={storeEdit.values?.name}
						margin='normal'
						required
						fullWidth
						id='name'
						label='Tên cửa hàng'
						name='name'
						autoComplete='name'
						autoFocus
						onChange={handleChange}
					/>
					<span style={{ color: '#ff0000' }}>{storeEdit.errors?.name}</span>
					<FormControlLabel
						control={
							<Switch
								color='success'
								onClick={() => {
									setDisplayTransferInfo(!displayTransferInfo)
								}}
								checked={displayTransferInfo}
							/>
						}
						label='Hiện thông tin chuyển khoản'
					/>
					<TextField
						value={storeEdit.values?.bank}
						margin='normal'
						fullWidth
						label='Ngân hàng'
						name='bank'
						onChange={handleChange}
					/>
					<TextField
						value={storeEdit.values?.account_name}
						margin='normal'
						fullWidth
						label='Chủ tài khoản'
						name='account_name'
						onChange={handleChange}
					/>
					<TextField
						value={storeEdit.values?.account_number}
						margin='normal'
						fullWidth
						label='Số tài khoản'
						name='account_number'
						onChange={handleChange}
					/>
					<TextField
						value={storeEdit.values?.bank}
						margin='normal'
						fullWidth
						label='Ngân hàng'
						name='bank'
						onChange={handleChange}
					/>
					<Box sx={{ mt: 2 }}>
						<Button
							sx={{
								marginLeft: 'auto',
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							fullWidth
							size='small'
							variant='contained'
							onClick={() => {
								const confirmEdit = window.confirm('Bạn có chắc muốn cập nhật thông tin cho cửa hàng này?')
								if (confirmEdit) {
									editStore()
								}
							}}>
							Cập nhật
						</Button>
					</Box>
				</Card>
			</Box>
		</UserLayout>
	)
}
